<script>
import { layoutMethods } from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { reportsMethods, reportsComputed, exportMethods,erpFixMessages, mopMethods, mopComputed } from "@/state/helpers"
import Swal from 'sweetalert2';
import moment from 'moment';

/**
 * E-Load list component
 */
export default {
  page: {
    title: "E-Load"
  },
  data() {
    return {
      dataList: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      filter: null,
      filterOn: [],
      sortBy: "value",
      sortDesc: false,
      sortingValue:{
        sort : "id",
        orderDesc : true,
      },
      fields: [
        {
          key: "transaction_id",
          sortable: true,
        },
        {
          key: "customer_name",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
        },

        {
          key: "wallet",
          sortable: true,
        },
       
        {
          key: "payment_method",
          sortable: true,
        },

        {
          key: "amount",
          sortable: true,
          thClass: "text-end",
        },

        {
          key: "service_fee",
          label: "Service Fee",
          sortable: true,
          thClass: "text-end",
        },

        {
          key: "date",
          sortable: true,
        },
      ],
      transView: {
        id: '',
        type: '',
        data: {
          amount: 0,
          fee: 0,
          net_amount: 0,
          status:''
        }
      },
      view: {
        id: 0,
        userId: 0,
        transactionId: "",
        wallet: "",
        amount: 0,
        topupValue: 0,
        paymentMethod: "",
        date: "",
        updated_at: "",
        customerInfo: {
          userId: 0,
          businessId: 0,
          name: "",
          businessName: "",
          mobile: "",
          email: null,
          address: ""
        }
      },
      coinvalue: "",
      statusValue: "",
      typeValue: null,
      datepickervalue: "",
      showModal: false,
      submitted: false,

      selected: null,
      options: [
        { value: "A", text: "TM (from options prop)" },
        { value: "B", text: "Globe (from options prop)" },
      ],

      searchValue: {
        searchField: null,
        search: "",
        status: null,
        dateRange: null,
        payment_method: null,
        sort: 'id',
        orderDesc: true
      },
      searchList: [
        { text: "Search All", value: null },
        { text: "Wallet", value: "wallet" },
        // { text: "Status", value: "status" },
        { text: "Merchant Name", value: "name" },
        // { text: "Payment Method", value: "payment_method" },
        { text: "Transaction ID", value: "transaction_id" },
      ],
      statusList: [
        { text: "All", value: null },
        { text: "Pending", value: "pending" },
        { text: "Failed", value: "failed" },
        { text: "Success", value: "success" },
      ],
      walleTypes: [
        { text: 'Select Wallet Type', value: null },
        { text: "ELoad", value: "eload" },
        { text: "Mobile Legend Diamond", value: "Mobile Legend Diamond" },
        { text: "Bills Payment", value: "Bills Payment" }
      ],
      actionIndex: -1,
      exportFilters: {
        wallet: null,
        payment_method: [],
        date_range: null,
      },
      exportFiltersValidation: {
          wallet: false,
          payment_method: false,
          date_range: false
      },
      paymentOptions: [
        { text: "All", value: null },
      ],
      selectedPaymentOption: [],
      isRange: null,
      rangeOptions: {
        mode: "range",
      },
    };
    
  },
  components: {
    flatPickr
  },
  computed: {
    ...reportsComputed,
    ...erpFixMessages,
    ...mopComputed,
    rows() {
      return this.dataList.length;
    },
  },
  mounted() {
    // this.getTransactionLogs();
    

    this.changeTitle({title: 'Transaction Logs'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'Report', to: { name: 'Report'}},
        { text: 'Topup Transaction', to: { name: 'Topup Transaction'}},
      ]
    });
    this.getLogs();
    this.getPaymentMethods();
  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    ...exportMethods,
    ...mopMethods,
    async onExport(){
      await this.onPageUpdate('reset');
      if(this.topupLogsTotalRows ==0){
        Swal.fire("Failed!", this.exportNullPrompt, "warning");
        return;
      }
      let params = Object.assign(
        // this.searchValue,
        {
          module: 'eload_transactions',
          email: JSON.parse(localStorage.getItem('userData')).email,
          "orderDesc": this.sortingValue["orderDesc"],
          "sort": this.sortingValue["sort"],
          "dateRange": this.searchValue["dateRange"],
          "status": this.searchValue["status"],
          "search": this.searchValue["search"],
          "searchField": this.searchValue["searchField"],
          "payment_method": this.searchValue["payment_method"],
        });

      // delete params.page;
      // delete params.rows;
      
      this.exportReport(params)
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
    },
    fixedAmount(string)
    {
      let str = string;
      return string.substring(0, str.length - 2) + '.' + str.substr(str.length - 2, str.length);
    },
    getStatusTransClassColor(data) {
      return data === 'EXPIRED' ? 'text-danger fw-medium m-0' : data === 'PAID' ? 'text-success fw-medium m-0' : 'text-warning fw-medium m-0'; 
    },
    getStatusClassColor(data) {
      return data === 'FAILED' ? 'text-danger fw-medium m-0' : data === 'SUCCESS' ? 'text-success fw-medium m-0' : 'text-warning fw-medium m-0'; 
    },
    fetchTranstionDetails(id) {

      this.fetchPaymongoTransaction({transactionId: id})
      .then((response) => {
          this.transView =  {
                data: response.attributes,
                id: response.id,
                type: response.type
            }
      })
      .catch((err) => {
            Swal.fire("Error!", `An error occured for fetching Paymongo Source Transaction: ${err}`, "error");
            console.log(err);
         });
    },
    async getLogs() {
      var date_to = moment().format('YYYY-MM-DD');
      //var date_from = moment().subtract(1, 'months').format('YYYY-MM-DD');
      var date_range = date_to + ' to ' + date_to;
      this.searchValue.dateRange = date_range
      await this.getTopupLogs({
        page: this.currentPage,
        rows: this.perPage,
        ...this.sortingValue,
        dateRange: date_range
      });
    },
    async searchLog() {
      await this.getTopupLogs({
        page: this.currentPage,
        rows: this.perPage,
        ...this.searchValue,
        ...this.sortingValue
      })
    },
    async onPageUpdate(reset = "") {
      if(this.searching || this.searchValue.status != null || this.searchValue.dateRange != null || this.searchValue.sort != null || this.searchValue.payment_method != null) {
        if(reset == "reset"){
          this.currentPage = 1
        }
        await this.searchLog()
      } else {
        await this.getLogs()
      }
    },
    async onSearch() {
      this.currentPage = 1
      console.log(">>>>>>>>>1",this.searching)
      if (this.searchValue.search) {
        this.searching = true
        console.log(">>>>>>>>>2",this.searching)
        await this.searchLog()
      } else {
        this.searching = false
        this.searchValue = {
          search: null,
          searchField: null,
        }
        console.log(">>>>>>>>>3",this.searching)
        await this.getLogs()
      }
    },
    infoModalFunction(data) {
      this.view = data
      this.$router.push({ path: `topup-transaction/${data.transactionId}` });
      //console.log(JSON.stringify(this.view))
    },
    exportLogs() {
      // this.$bvModal.hide("bv-modal-export")
      //this will validate the required fields
      this.exportFiltersValidation.date_range = this.exportFilters.date_range == null || this.exportFilters.date_range.length < 2 ? true:false;
      this.exportFiltersValidation.payment_method = this.exportFilters.payment_method.length == 0 ? true:false;
      this.exportFiltersValidation.wallet = this.exportFilters.wallet == "" || this.exportFilters.wallet.length == 0 ? true:false;
      if(!(this.exportFiltersValidation.date_range == false && this.exportFiltersValidation.payment_method == false && this.exportFiltersValidation.wallet == false)){
        return false;
      }
      let dates = this.exportFilters.date_range.split(' to '),
          start_date = dates[0],
          end_date = dates[1]
      const user_email = JSON.parse(localStorage.getItem('userData')).email
      let filters = {
        ...this.exportFilters,
        date_start: start_date,
        date_end:end_date
      }
      this.exportTopupLogs({
        filters: filters,
        emailAddress: user_email
      }).then((response) => {
        this.$bvModal.hide("bv-modal-export")
        console.log("EXport: ", response);
        Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success");

        return;
      })
      .catch(function (error) {
        console.log(error);
        Swal.fire("Export Data!", error, "info");
        return;
      });
    },
    onDisplayChange(){
      console.log(this.topupLogsTotalRows,this.perPage,this.topupLogs.length,(this.topupLogs.length < this.topupLogsTotalRows && this.topupLogs.length != this.perPage));
      if(
        (this.topupLogs.length < this.topupLogsTotalRows && this.topupLogs.length != this.perPage) || // condition for incrementing display per page
        (this.topupLogs.length == this.topupLogsTotalRows && this.perPage < this.topupLogs.length) // condition for decreasing display per page
        ){
        this.onPageUpdate('reset')
      }
    },
    refresh(){
      this.sortingValue.sort = "";
      this.sortingValue.orderDesc = "";
      this.getLogs();
    },
    tableSorting(action){
        var column = "";
        switch(action.sortBy){
            case 'transaction_id' :
                column = 'transaction_id';
                break;
            case 'customer_name' :
                column = 'name';
                break;
            case 'status' :
                column = 'status';
                break;
            case 'wallet' :
                column = 'wallet';
                break;
            case 'payment_method' :
                column = 'payment_method';
                break;
            case 'amount' :
                column = 'amount';
                break;
            case 'date' :
                column = 'date';
                break;
            case 'service_fee' :
                column = 'service_fee';
                break;
        }
        
        this.sortingValue.sort = column;
        this.sortingValue.orderDesc = action.sortDesc;
        this.getTopupLogs({
          page: this.currentPage,
          rows: this.perPage,
          ...this.searchValue,
          ...this.sortingValue
        })
    },
    getPaymentMethods(){
        this.listAllMop()
          .then(() => {
            this.mops.eload_wallet.forEach(mop => {
              let mopName = mop.name == 'PayMaya' ? 'Maya' : mop.name;
              let existing = this.paymentOptions.some(p => p.text == mopName && p.value == mopName);
              if (!existing) {
                this.paymentOptions.push({
                  text: mopName,
                  value: mopName,
                })
              }
            })
          })
      }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <span class="text-muted fw-normal ms-2">{{topupLogsTotalRows}}</span>
                    Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->
              <div class="col-md-6" style="text-align: right;">
                <button class="btn btn-secondary" @click="refresh()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                </button>
              </div>
              <!-- Search and button -->
              <div class="row mt-3 mb-2 px-3">
                <div class="col-md-4 ta-right">
                  <b-form-group description="Search Keyword">
                    <form class="d-flex" @submit.prevent="onSearch()">
                      <b-form-group id="input-group-3" label-for="input-3">
                        <b-form-select
                          class="form-select rounded-0 rounded-start shadow-none"
                          style="width: fit-content"
                          id="input-3"
                          v-model="searchValue.searchField"
                          :options="searchList"
                        ></b-form-select>
                      </b-form-group>

                      <b-input-group>
                        <b-form-input
                          class="rounded-0"
                          v-model="searchValue.search"
                        ></b-form-input>
                        <b-input-group-append  v-if="false">
                          <b-button
                            variant="primary"
                            type="submit"
                            class="rounded-0 rounded-end px-2"
                          >
                            <i class="bx bx-search bx-fw"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </form>
                  </b-form-group>
                </div>
                <div class="col-md-8">
                  <div
                    class="
                      d-flex
                      flex-wrap
                      align-items-start
                      justify-content-md-end
                      mt-2 mt-md-0
                      gap-2
                      mb-3 ta-right
                    "
                  >
                    <b-form-group label-for="status" description="Filter by status">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:fit-content"
                        v-model="searchValue.status"
                        :options="statusList"
                      ></b-form-select>
                    </b-form-group>
                    <b-form-group label-for="payment_method" description="Filter by payment method">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:fit-content"
                        v-model="searchValue.payment_method"
                        :options="paymentOptions"
                      ></b-form-select>
                    </b-form-group>
                    <b-form-group description="Filter by date added">
                      <flat-pickr
                        v-model="searchValue.dateRange"
                        :config="rangeOptions"
                        placeholder="Select a date range"
                        class="form-control"
                        style="width: fit-content"
                      ></flat-pickr>
                    </b-form-group>
                    <a class="btn btn-primary h-fit" @click="onPageUpdate('reset')">
                      <i class='bx bx-search bx-fw'></i>Search
                    </a>
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary"
                      data-bs-toggle="modal"
                      @click="onExport"
                    >
                      <i class="uil uil-export me-1"></i>
                      Export
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
            <!-- end row -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="topupLogs"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="table-check"
                  @sort-changed="tableSorting"
                >
                  <template #cell(transaction_id)="data">
                    <b-link
                      class="fw-medium"
                      @click="
                        infoModalFunction(data.item);
                      "
                      >{{ data.item.transactionId }}
                    </b-link>
                  </template>

                  <template #cell(customer_name)="data">
                    <span class="text-body fw-medium m-0">{{
                      data.item.customerInfo.name
                    }}</span>
                  </template>

                  <template #cell(wallet)="data">
                    <p class="text-body m-0">
                      {{ data.item.wallet }}
                    </p>
                  </template>

                   <template #cell(status)="data">
                    <p class="text-body m-0">
                      <span :class="getStatusClassColor(data.item.status.toUpperCase())"> {{  data.item.status.toUpperCase()}}  </span>
                    </p>
                  </template>

                  <template #cell(payment_method)="data">
                    <p class="text-body m-0">
                      {{ data.item.paymentMethod }}
                    </p>
                  </template>

                  <template #cell(amount)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ data.item.amount  |  numberWithCommas }}
                    </p>
                  </template>
                  <template #cell(service_fee)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ (data.item?.service_fee ?? 0)  |  numberWithCommas }}
                    </p>
                  </template>

                  <template #cell(date)="data">
                    <p class="text-body m-0">
                      {{ data.item.date | formatDate }}
                    </p>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="topupLogsTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="topupLogsTotalRows != 0 && topupLogsTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                      v-if="topupLogsTotalRows > perPage"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        :total-rows="topupLogsTotalRows"
                        @input="onPageUpdate()"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            
            <b-modal
              id="bv-modal-export"
              centered
              no-close-on-esc
              no-close-on-backdrop
            >
              <template v-slot:modal-header>
                <h4 class="modal-title">
                  <i class="uil uil-export me-1"></i>
                  <b>Export</b>
                </h4>
              </template>
              <form class="px-4 py-3">
                <div class="row">
                  <div class="col-md">
                    <b-form-group>
                      <label class="form-label small fw-bold">Wallet Type <span class="required-input">* </span></label>
                      <b-form-select
                        class="form-select rounded-0 rounded-start shadow-none ml-5"
                        style="width: 250px"
                        id="input-3"
                        v-model="exportFilters.wallet"
                        :options="walleTypes"
                        required
                        :class="{
                            'is-invalid' : exportFiltersValidation.wallet
                        }"
                      ></b-form-select>
                      <div
                          v-if="exportFiltersValidation.wallet"
                          class="invalid-feedback">
                          Wallet type is required.
                      </div>
                    </b-form-group>
                    <b-form-group>
                      <label class="form-label small fw-bold mt-3">Payment Method <span class="required-input">* </span></label>
                      <b-form-checkbox-group
                        class="ml-75 custom-checkbox-method d-flex"
                        id="checkbox-group-1"
                        v-model="exportFilters.payment_method"
                        :options="paymentOptions"
                        name="flavour-1a"
                        :class="{
                            'is-invalid' : exportFiltersValidation.payment_method
                        }"
                      ></b-form-checkbox-group>
                      <div
                          v-if="exportFiltersValidation.payment_method"
                          class="invalid-feedback">
                          Payment method is required.
                      </div>
                    </b-form-group>
                  
                    
                    <div class="mb-3">
                      <label class="form-label mt-3">Date Range <span class="required-input">* </span></label>
                      <div class="d-flex">
                        <i class='bx bx-calendar calendar-icon'></i>
                      <flat-pickr
                        v-model="exportFilters.date_range"
                        :config="rangeOptions"
                        placeholder="Select a date"
                        class="form-control"
                        style="width: 100%"
                        :class="{
                            'is-invalid' : exportFiltersValidation.date_range
                        }"
                      ></flat-pickr>
                      </div>
                      <div
                          v-if="exportFiltersValidation.date_range"
                          class="invalid-feedback">
                          Date range is required.
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <template v-slot:modal-footer>
                <div class="text-end mt-3">
                  <b-button
                    variant="light"
                    class="w-sm"
                    @click="$bvModal.hide('bv-modal-export')"
                    >Close</b-button
                  >
                  <b-button type="submit" variant="primary" class="w-sm ms-2" @click="exportLogs()"
                    >Submit</b-button
                  >
                </div>
              </template>
            </b-modal>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
<style>
.custom-checkbox-method label {
    margin-left: 10px;
    
}

.custom-checkbox-method input {
    margin-left: 15px;
    
}

.required-input {
  color:red;
}

.calendar-icon {
  display: block;
  font-size: 20px;
  padding: 8px;
  background-color: grey;
}
</style>